export default "__VITE_ASSET__CZTvhK8$__"